import type { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { Chip, Icon, StaticPercentSpan, Tooltip } from '@myn/mui';

import ConditionalCurrencyField from '../../../atoms/ConditionalCurrencyField.jsx';
import { Currency } from '../../../types/_campaigns/campaigns.js';

type Props = {
  previousBudget: number | string;
  currentBudget: number | string;
  differencePercent: number;
  currency?: Currency | null;
};

const BudgetDifference: FC<Props> = ({
  previousBudget,
  currentBudget,
  differencePercent,
  currency,
}) => {
  const { t } = useTranslation('@myn/planning');
  return (
    <Tooltip
      title={
        <>
          <p>
            {t('Current version')}:{' '}
            <ConditionalCurrencyField
              currency={currency}
              value={currentBudget}
            />
          </p>
          <p>
            {t('Previous version')}:{' '}
            <ConditionalCurrencyField
              currency={currency}
              value={previousBudget}
            />
          </p>
        </>
      }
    >
      <Chip
        variant="outlined"
        icon={
          <Icon component={differencePercent > 0 ? 'ArrowUp' : 'ArrowDown'} />
        }
        label={
          <StaticPercentSpan
            number={differencePercent}
            options={{ minDecimals: 2, maxDecimals: 2 }}
          />
        }
      />
    </Tooltip>
  );
};

export default BudgetDifference;
